import { randomId } from "../utils/ui-utils";
class NotificationQueue {
    constructor() {
        Object.defineProperty(this, "listeners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "notifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    addNotification(notification) {
        this.notifications = [
            Object.assign({ key: randomId("global-snackbar") }, notification),
        ];
        this.listeners.forEach((listener) => {
            listener(this.notifications);
        });
    }
    removeNotification(notification) {
        this.notifications = this.notifications.filter((old) => old !== notification);
        this.listeners.forEach((listener) => {
            listener(this.notifications);
        });
    }
    addListener(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter((old) => old !== listener);
        };
    }
}
export default new NotificationQueue();
//# sourceMappingURL=NotificationQueue.js.map